import React, { useState } from 'react';

function MobileDoctorSpecialization({ user, onBack }) {
  const [form, setForm] = useState({
    specialization: user?.specialization || '',
    nmcNumber: user?.nmcNumber || '',
    experience: user?.experience || '',
    hospital: user?.hospital || '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const specializations = [
    'Cardiology', 'Neurology', 'Pediatrics', 'Dermatology',
    'General Physician', 'Endocrinology', 'Orthopedics',
    'General Surgery', 'Psychiatry', 'Ophthalmology',
  ];

  const handleSave = async () => {
    setLoading(true);
    setTimeout(() => {
      setMessage('✅ Specialization updated!');
      setLoading(false);
    }, 1000);
  };

  return (
    // REMOVED 'pt-16' HERE TO FIX THE BIG GAP
    <div className="pb-6 bg-[#f9f9fc] min-h-full" style={{ fontFamily: 'Inter, sans-serif' }}>
      
      {/* SUB-SCREEN HEADER */}
      <div className="flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-100 sticky top-0 z-10">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 active:scale-95 transition-all">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <span className="font-black text-[#0d1b2a] text-base">Specialization & NMC</span>
      </div>

      <div className="px-4 pt-4 pb-4 space-y-4">
        {/* Verified Badge */}
        <div className="bg-green-50 border border-green-200 rounded-2xl p-4 flex items-center gap-3">
          <span className="material-symbols-outlined text-green-600 text-2xl" style={{ fontVariationSettings: '"FILL" 1' }}>verified</span>
          <div>
            <p className="font-bold text-green-700 text-sm">Account Verified</p>
            <p className="text-xs text-green-600">Your NMC credentials have been verified by admin</p>
          </div>
        </div>

        {message && (
          <div className="p-3 bg-green-50 border border-green-200 rounded-xl text-green-700 text-sm text-center font-semibold">
            {message}
          </div>
        )}

        <div className="bg-white rounded-2xl border border-gray-100 p-4 space-y-4" style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
          {/* Specialization */}
          <div>
            <label className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 block">Specialization</label>
            <select value={form.specialization} onChange={e => setForm({ ...form, specialization: e.target.value })}
              className="w-full bg-gray-50 rounded-xl px-3 py-3 border border-gray-200 text-sm text-[#1a1c1e] outline-none focus:border-[#0B3C95]">
              <option value="">Select specialization</option>
              {specializations.map(s => <option key={s}>{s}</option>)}
            </select>
          </div>

          {/* NMC Number */}
          <div>
            <label className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 block">NMC Registration Number</label>
            <div className="flex items-center gap-3 bg-gray-50 rounded-xl px-3 py-3 border border-gray-200 focus-within:border-[#0B3C95] focus-within:bg-white transition-all">
              <span className="material-symbols-outlined text-gray-400 text-lg">badge</span>
              <input type="text" value={form.nmcNumber} placeholder="NMC-XXXX-XXXX"
                onChange={e => setForm({ ...form, nmcNumber: e.target.value })}
                className="flex-1 bg-transparent border-none outline-none text-sm text-[#1a1c1e] placeholder-gray-400" />
            </div>
          </div>

          {/* Experience */}
          <div>
            <label className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 block">Years of Experience</label>
            <div className="flex items-center gap-3 bg-gray-50 rounded-xl px-3 py-3 border border-gray-200 focus-within:border-[#0B3C95] focus-within:bg-white transition-all">
              <span className="material-symbols-outlined text-gray-400 text-lg">work</span>
              <input type="number" value={form.experience} placeholder="e.g. 5"
                onChange={e => setForm({ ...form, experience: e.target.value })}
                className="flex-1 bg-transparent border-none outline-none text-sm text-[#1a1c1e] placeholder-gray-400" />
            </div>
          </div>

          {/* Hospital */}
          <div>
            <label className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 block">Current Hospital / Clinic</label>
            <div className="flex items-center gap-3 bg-gray-50 rounded-xl px-3 py-3 border border-gray-200 focus-within:border-[#0B3C95] focus-within:bg-white transition-all">
              <span className="material-symbols-outlined text-gray-400 text-lg">local_hospital</span>
              <input type="text" value={form.hospital} placeholder="Apollo Hospital, Hyderabad"
                onChange={e => setForm({ ...form, hospital: e.target.value })}
                className="flex-1 bg-transparent border-none outline-none text-sm text-[#1a1c1e] placeholder-gray-400" />
            </div>
          </div>
        </div>

        <button onClick={handleSave} disabled={loading}
          className="w-full py-4 bg-[#0B3C95] text-white font-bold rounded-2xl text-sm active:scale-95 disabled:opacity-50 transition-all"
          style={{ boxShadow: '0 8px 25px rgba(11,60,149,0.3)' }}>
          {loading ? '⏳ Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
}

export default MobileDoctorSpecialization;